module.exports = __webpack_public_path__ + "img/1493315296.1dc10c0f.jpg";